import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { site } from '../data/site';
export function FinalCta() {
  return <section id="contact" className="bg-brand py-20 lg:py-24" data-id="element-139" data-mp="vgqxol99r6hi">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[1.3fr_1fr] lg:items-center lg:px-8" data-id="element-140" data-mp="19fgvy47trc7g">
        <div data-id="element-141" data-mp="15d40c8mskuoe">
          <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.95] text-white sm:text-6xl lg:text-7xl" data-id="element-142" data-mp="15ckist1208aw">
            Something broken?
            <br data-id="element-143" data-mp="1ee1vs2j5ztvd" />
            <span className="text-ink" data-id="element-144" data-mp="1eek25rzjjoh0">Let’s fix it this week.</span>
          </h2>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-145" data-mp="1t2omf0e8s81w">
            <a href={site.phoneHref} className="flex items-center justify-center gap-3 rounded-lg bg-ink px-7 py-4 font-display text-2xl font-bold text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-146" data-mp="1t251datap3jn">
              <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-147" data-mp="1x51onets5ntx" /> {site.phone}
            </a>
            <a href="#quote" className="flex items-center justify-center rounded-lg border-2 border-white px-7 py-4 font-display text-2xl font-bold text-white transition-colors duration-150 hover:bg-white hover:text-brand" data-id="element-148" data-mp="n649jisb5ija">
              Get Your Free Quote
            </a>
          </div>
        </div>

        <div className="rounded-2xl bg-white/10 p-7 ring-1 ring-white/20" data-id="element-149" data-mp="124g4nl018j8c">
          <p className="flex items-center gap-2 font-display text-xl font-bold uppercase text-white" data-id="element-150" data-mp="163fbxc98ks2y">
            <MapPinIcon className="h-5 w-5" aria-hidden="true" data-id="element-151" data-mp="1b28on2gp8f22" /> Proudly serving
          </p>
          <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5" data-id="element-152" data-mp="1fvbaeof8ik7p">
            {site.serviceAreas.map(area => <li key={area} className="font-medium text-white" data-id="element-153" data-mp="1kstkii4zn5ha">
                {area}
              </li>)}
          </ul>
          <p className="mt-5 border-t border-white/20 pt-4 text-sm text-white/85" data-id="element-154" data-mp="1pqmrhde483im">
            Don’t see your area? Call us — if we can get there, we’ll fix it.
          </p>
        </div>
      </div>
    </section>;
}